// España
export default {
	status: {
		400: "¡Error en la solicitud! Por favor, inténtalo de nuevo más tarde",
		401: "¡La sesión de inicio de sesión ha caducado! Por favor, vuelve a iniciar sesión",
		403: "La cuenta actual no tiene permisos de acceso",
		404: "El recurso que estás intentando acceder no existe",
		405: "¡Método de solicitud incorrecto! Por favor, inténtalo de nuevo más tarde",
		408: "¡Tiempo de espera de la solicitud! Por favor, inténtalo de nuevo más tarde",
		500: "El servicio encontró una excepción",
		990: "Su cuenta ha estado congelada debido a tareas no completadas durante mucho tiempo",
		10030008: "Devuelva el fondo de asistencia antes de solicitar la retirada de efectivo",
		10030010: "El código de invitación no existe",
		10030011: "Se superó el número máximo de veces de registro",
		10030012: "No cumple con las condiciones de registro, por favor completa la tarea primero",
		10030013: "Error de configuración de inicio de sesión, por favor, contacta con el servicio de atención al cliente",
		10030014: "No está dentro del período de tiempo permitido",
		10030015: "El miembro no existe",
		10030016:
			"Estimado usuario: ¡Felicidades! Ha completado con éxito el 100% de la promoción de su producto. Por favor, póngase en contacto con el soporte de la plataforma para solicitar un reinicio.",
		10030017: "No se puede coincidir con el producto, por favor, contacta con el servicio de atención al cliente",
		10030018: "Saldo de cuenta insuficiente",
		10030019: "La cuenta ha sido desactivada",
		10030020: "Cuenta prohibida para operar",
		10030021: "Retiro de cuenta prohibido",
		10030022: "Error de contraseña de transacción",
		10030023: "La cuenta de retiro no está vinculada, por favor, vincula la cuenta de retiro primero",
		10030024: "Error de contraseña antigua",
		10030027:
			"Su retiro está restringido. Por favor, póngase en contacto con el servicio de atención al cliente para obtener más detalles",
		10030028: "Las puntuaciones crediticias bajas le impiden retirar dinero",
		10030030: "No está dentro del período de tiempo permitido",
		10030031: "Póngase en contacto con el servicio de atención al cliente para restablecer la tarea de hoy",
		10030050:
			"El pedido ha caducado. Por favor, póngase en contacto con el servicio de atención al cliente para obtener ayuda."
	},
	errorHandler: {
		InternalError: "Error interno en el motor JavaScript",
		ReferenceError: "Objeto no encontrado",
		TypeError: "Tipo o objeto incorrecto utilizado",
		RangeError: "Parámetro fuera de rango al usar objetos integrados",
		SyntaxError: "Error de sintaxis",
		EvalError: "Uso incorrecto de Eval",
		URIError: "Error URI",
		UnknownError: "Desconocido"
	},
	Network: {
		timedout: "¡Tiempo de espera de la solicitud! Por favor, inténtalo de nuevo más tarde",
		error: "¡Error de red! Por favor, inténtalo de nuevo más tarde"
	},
	request: {
		NoMoreData: "No hay más datos",
		OnlyImage: "Por favor, suba solo archivos de imagen.",
		FileMaxSize: "El tamaño del archivo supera el valor máximo, que es {0}M"
	},
	response: {
		loading: "Cargando",
		success: "Éxito",
		fail: "Fallo",
		complete: "Completo"
	},
	page: {
		noVerify: "Billetera no verificada, por favor verifique su billetera primero",
		notexist: "Lo siento, la página que estás intentando acceder no existe~"
	}
};
